export default __webpack_public_path__ + "static/media/gallery-1-1.02e32fa1.jpg";